import React, { FC, lazy } from 'react'
import { Switch } from 'react-router-dom'
import { FrontUrls } from 'Constants/FrontUrls'
import { LazyRoute, filtersSlice, PAGE_SLUG } from 'Modules'
import { useAppDispatch } from 'Src/hooks'
import { useUnmount } from 'Src/hooks/useUnmount'
import { useEffectOnce } from 'Src/hooks/useEffectOnce'
import { SocketChannel, socketSlice } from 'Modules/Socket'

const OrdersListLazy = lazy(
	() => import('Pages/orders_design/components/desktop_orders/OrdersList')
)
const OrderEditLazy = lazy(() => import('Pages/orders_design/components/desktop_orders'))

const actions = {
	clearFilters: filtersSlice.actions.clearFilters,
	subscribeChannels: socketSlice.actions.subscribeChannels,
	unSubscribeChannels: socketSlice.actions.unSubscribeChannels,
}

export const DesktopOrdersRouter: FC = () => {
	const { clearFilters, subscribeChannels, unSubscribeChannels } = useAppDispatch(actions)

	useEffectOnce(() => {
		subscribeChannels([SocketChannel.LEAD_CHANNEL, SocketChannel.RESERVE_ACCOUNT_CHANNEL])
		return () => {
			unSubscribeChannels([SocketChannel.LEAD_CHANNEL, SocketChannel.RESERVE_ACCOUNT_CHANNEL])
		}
	})

	useUnmount(() => {
		clearFilters(PAGE_SLUG.ORDERS_REDESIGN)
	})

	return (
		<Switch>
			<LazyRoute exact path={FrontUrls.orders_redesign.edit} lazyComponent={OrderEditLazy} />
			<LazyRoute exact path={FrontUrls.orders_redesign.create} lazyComponent={OrderEditLazy} />
			<LazyRoute exact path={FrontUrls.orders_redesign.index} lazyComponent={OrdersListLazy} />
		</Switch>
	)
}
